import React from "react";
import { Badge } from "react-bootstrap";
import { Clock, Users, ChefHat, Sparkles } from "lucide-react";

const RecipeHeader = ({ recipe, servings }) => {
    const heroImage = recipe.media?.find(m => m.isHeroShot)?.url || recipe.media?.[0]?.url;

    return (
        <div className="flex-shrink-0 mb-4">
            <div className="row g-4 justify-content-center"> {/* Centered content */}
                {/* Hero Image - Wide Format */}
                <div className="col-12">
                    <div className="rounded-4 overflow-hidden shadow-sm position-relative mx-auto" style={{ height: '30vh', maxHeight: '350px', maxWidth: '1200px' }}>
                        {/* Horizontal Gradient Overlay - White, fades out to right */}
                        <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: 'linear-gradient(to right, rgba(255,255,255,0.95), rgba(255,255,255,0.8) 40%, rgba(255,255,255,0.2) 70%, transparent)' }}></div>

                        <img
                            src={heroImage || "https://pixabay.com/illustrations/paper-old-vintage-compass-retro-8775689/"}
                            alt={recipe.title}
                            className="w-100 h-100 object-fit-cover"
                            style={{ zIndex: -1 }}
                        />
                        <div className="position-absolute bottom-0 start-0 p-5 z-2 text-dark w-100">
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <Badge bg="secondary" className="bg-opacity-10 text-dark px-2 py-1 rounded-pill font-sans fw-semibold small border border-dark border-opacity-10">
                                    {recipe.category || "Hauptgericht"}
                                </Badge>
                                {recipe.tags && recipe.tags.map((tag, i) => (
                                    <Badge key={i} bg="light" text="dark" className="border fw-normal px-2 py-1 rounded-pill font-sans small">
                                        {typeof tag === 'string' ? tag : tag.name}
                                    </Badge>
                                ))}
                                {recipe.isOptimized && (
                                    <Badge bg="warning" text="dark" className="d-flex align-items-center gap-2 px-2 py-1 rounded-pill shadow-sm small">
                                        <Sparkles size={12} fill="currentColor" /> KI
                                    </Badge>
                                )}
                            </div>
                            <h1 className="fw-bold mb-3 font-serif display-5">{recipe.title}</h1>
                            <p className="text-secondary font-sans mb-4" style={{ maxWidth: '700px', fontSize: '1.1rem', lineHeight: '1.6' }}>{recipe.description}</p>

                            <div className="d-flex flex-wrap gap-4 text-dark font-sans small fw-bold text-uppercase tracking-wide opacity-75">
                                <div className="d-flex align-items-center gap-2">
                                    <Clock size={16} />
                                    <span>{parseInt(recipe.prepTime || 0) + parseInt(recipe.cookTime || 0)} Min.</span>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <Users size={16} />
                                    <span>{servings} Pers.</span>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <ChefHat size={16} />
                                    <span>
                                        {recipe.difficulty === 'easy' ? 'Einfach' :
                                            recipe.difficulty === 'hard' ? 'Schwer' : 'Mittel'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecipeHeader;
